<template>
  <div>
    <JqxWindow ref="myWindow" :theme="'material'" :width="930" :height="650" :resizable="true" :isModal="true"
               :autoOpen="false" @open="onOpen($event)" :initContent="init">
      <div class="col-md"><strong>Vettori</strong>
      </div>
      <div>
        <JqxTabs ref="tab" :theme="'material'" :animationType="'fade'" :autoCreate="false">
          <ul id="muoviti" style="margin-left: 5px">
            <li>Dati generali</li>
            <li>Extra</li>
            <li>Contabile</li>
          </ul>
          <div>
            <JqxSplitter ref="splitter" :width="850" :heigth="600" :autoCreate="false" :panels="panels">
              <div class="splitter-panel" :theme="'material'">
                <PlaceAutoGoogleWithoutMaps ref="autogoogle"></PlaceAutoGoogleWithoutMaps>
              </div>
              <div class="splitter-panel">
                <div style="margin-top: 5px;margin-left: 5px;">
                  <div class="form-group">
                    <label>Partita iva</label>
                    <br>
                    <JqxInput :theme="'material'" ref="partita_iva"></JqxInput>
                  </div>

                  <div class="form-group">
                    <label>Codice fiscale</label>
                    <br>
                    <JqxInput :theme="'material'" ref="codice_fiscale"></JqxInput>
                  </div>

                  <div class="form-group">
                    <label>Indirizzo PEC</label>
                    <br>
                    <JqxInput :theme="'material'" ref="indirizzo_pec"></JqxInput>
                  </div>

                  <div class="form-group">
                    <label>Indirizzo e-mail</label>
                    <br>
                    <JqxInput :theme="'material'" ref="indirizzo_email"></JqxInput>
                  </div>

                  <div class="form-group">
                    <label>Telefono</label>
                    <br>
                    <JqxInput :theme="'material'" ref="telefono"></JqxInput>
                  </div>

                  <div class="form-group">
                    <label>Fax</label>
                    <br>
                    <JqxInput :theme="'material'" ref="fax"></JqxInput>
                  </div>

                  <div class="form-group">
                    <label>Indirizzo web</label>
                    <br>
                    <JqxInput :theme="'material'" ref="indirizzo_web"></JqxInput>
                  </div>

                </div>
              </div>
            </JqxSplitter>
          </div>
          <div>
            <div class="form-group">
              <label>Note extra</label>
              <br>
              <JqxInput :theme="'material'" ref="note_extra"></JqxInput>
            </div>

            <div class="form-group">
              <label>Codice opzionale</label>
              <br>
              <JqxInput :theme="'material'" ref="codice_opzionale"></JqxInput>
            </div>

            <div class="form-group">
              <label>Tipologia</label>
              <br>
              <JqxInput :theme="'material'" ref="tipologia"></JqxInput>
            </div>

            <div class="form-group">
              <label>Note indirizzo</label>
              <br>
              <JqxInput :theme="'material'" ref="note_indirizzo"></JqxInput>
            </div>
            <div class="form-group">
              <label>Aliquota iva predefinita</label>
              <br>
              <JqxInput :theme="'material'" ref="aliquota_iva_predefinita"></JqxInput>
            </div>
            <div class="form-group">
              <label>Termini di pagamento</label>
              <br>
              <JqxInput :theme="'material'" ref="termini_di_pagamento"></JqxInput>
            </div>

          </div>
          <div>
            <div class="form-group">
              <label>Conto di pagamento predefinito</label>
              <br>
              <JqxInput :theme="'material'" ref="conto_di_pagamento_predefinito"></JqxInput>
            </div>

            <div class="form-group">
              <label>Tipologia</label>
              <br>
              <JqxInput :theme="'material'" ref="conto_di_pagamento_predefinito"></JqxInput>
            </div>

            <div class="form-group">
              <label>Riba iban</label>
              <br>
              <JqxInput :theme="'material'" ref="riba_iban"></JqxInput>
            </div>

            <div class="form-group">
              <label>Utilizza fatturazione elettronica</label>
              <br>
              <JqxInput :theme="'material'" ref="utilizza_fatturazione_elettronica"></JqxInput>
            </div>

            <div class="form-group">
              <label>Codice destinatario</label>
              <br>
              <JqxInput :theme="'material'" ref="codice_destinatario"></JqxInput>
            </div>

            <div class="form-group">
              <label>Referente</label>
              <br>
              <JqxInput :theme="'material'" ref="referente"></JqxInput>
            </div>

            <div class="form-group">
              <label>Referente</label>
              <br>
              <JqxInput :theme="'material'" ref="albo_autorasporti"></JqxInput>
            </div>
          </div>
        </JqxTabs>
        <card>
          <div class="float-right">
            <JqxButton :theme="'material'" @click="saveParent">
              Save
            </JqxButton>

            <JqxButton :theme="'material'" @click="cancelParent">
              Cancel
            </JqxButton>
          </div>
        </card>
      </div>
    </JqxWindow>
  </div>

</template>

<script>
  import JqxWindow from "~jqx/jqwidgets-vue/vue_jqxwindow.vue";
  import JqxButton from "~jqx/jqwidgets-vue/vue_jqxbuttons.vue";
  import JqxInput from "~jqx/jqwidgets-vue/vue_jqxinput.vue";
  import JqxNumberInput from "~jqx/jqwidgets-vue/vue_jqxnumberinput.vue";
  import PlaceAutoGoogleWithoutMaps from '.././google/PlaceAutoGoogleWithoutMaps';
  import JqxSplitter from '~jqx/jqwidgets-vue/vue_jqxsplitter.vue';
  import JqxTabs from '~jqx/jqwidgets-vue/vue_jqxtabs.vue';

  export default {
    name: "VettoriDetails",
    components: {
      JqxInput,
      JqxNumberInput,
      JqxButton,
      JqxWindow,
      PlaceAutoGoogleWithoutMaps,
      JqxSplitter,
      JqxTabs

    },
    data: function () {
      return {
        panels: [{size: 200}, {size: 200}]
      }
    },
    methods: {
      saveParent() {
        this.$parent.saveBtn();
      },
      init: function () {
        let options = {height: "80%", theme: "material"};
        this.$refs.tab.createComponent(options);
        //this.$refs.splitter.panels =[{ size: 400 },{ size: 400 }];
        let tmp = {width: "98%", height: "98%", theme: "material"};
        this.$refs.splitter.createComponent(tmp);
      },
      inittwo: function () {


      },
      cancelParent() {
        this.$parent.cancelBtn();
      },
      onOpen(event) {
        document.getElementById("muoviti").style.width = "500px";
      }
    },
    mounted: function () {

    }
  }
</script>

<style scoped>
  .jqx-splitter {
    border: none;
  }
</style>
